import React from "react";

export const GoogleMap: React.FC = () => {
  return (
    <div
      style={{
        position: "relative",
        textAlign: "right",
        width: "100%",
        overflow: "hidden",
        borderRadius: 8,
      }}
    >
      <div
        className="gmap_canvas"
        style={{
          overflow: "hidden",
          background: "none !important",
          width: "100%",
          height: "100%",
        }}
      >
        <iframe
          width="100%"
          height="100%"
          frameBorder="0"
          scrolling="no"
          marginHeight={0}
          marginWidth={0}
          src="https://maps.google.com/maps?width=500&amp;height=300&amp;hl=en&amp;q=hakob hakobyan 3&amp;t=h&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
        ></iframe>
      </div>
    </div>
  );
};
